'use client';

import { Box, Flex, Link } from "@chakra-ui/react";

export default function Live({ live }) {
  return (
  <Flex justifyContent={{ base: 'center'}} alignItems="center" py="4" px="4">
    <Box textAlign="center" fontWeight="bold" display="flex" alignItems="center" justifyContent="center">
      <Box mr="1" display="flex" alignItems="center" minW="96px">
        <Box
          as="span"
          display="inline-block"
          w="10px"
          h="10px"
          bgColor="white"
          borderRadius="50%"
          animation="pulse 1s infinite"
        />

        <Box ml="2">
          AO VIVO:
        </Box>
      </Box>

      <Link href={live.postPermalink} title={ live.postTitle } color="white" _hover={{ textDecoration: 'underline' }}>
        { live.postTitle }
      </Link>
    </Box>

    <style jsx>{`
      @keyframes pulse {
        0%, 100% {
          transform: scale(1);
          opacity: 1;
        }
        50% {
          transform: scale(1.5);
          opacity: 0.7;
        }
      }
    `}</style>
  </Flex>
  )
}
